import { salvarRascunho, carregarRascunho } from './db';
import type { DraftData, Atividade } from './types';
import { atualizarChecklistAtividades } from './progress';
import { setLastEditNow } from './lastedit';

const DEFAULT_DRAFT: DraftData = {
  objetivosGerais: '',
  objetivosEspecificos: '',
  justificativa: '',
  responsabilidadesUFC: '',
  responsabilidadesParceiro: '',
  atividadesConjuntas: '',
  direitosPI: '',
  atividades: [],
  tabelas_orcamento: []
};

const LIST_SEL = '#atividades-lista';
const ADD_BTN_ID = 'add-atividade';

function el<T extends Element = Element>(sel: string, ctx: ParentNode = document): T | null {
  return ctx.querySelector(sel) as T | null;
}
function els<T extends Element = Element>(sel: string, ctx: ParentNode = document): T[] {
  return Array.from(ctx.querySelectorAll(sel)) as T[];
}

function criarLinha(atividade?: Atividade): HTMLDivElement {
  const wrap = document.createElement('div');
  wrap.className = 'list-item';
  wrap.setAttribute('data-atividade-row', '1');

  const a = document.createElement('textarea');
  a.rows = 2;
  a.placeholder = 'Meta';
  a.className = 'input-meta';

  const b = document.createElement('textarea');
  b.rows = 2;
  b.placeholder = 'Indicador';
  b.className = 'input-indicador';

  if (atividade) {
    a.value = (atividade.nome ?? '').toString();
    b.value = (atividade.valor ?? '').toString();
  }

  const remover = document.createElement('button');
  remover.type = 'button';
  remover.className = 'remove-button';
  remover.textContent = 'x';

  const linha = document.createElement('div');
  linha.className = 'grid-atividade';
  linha.append(a, b);

  wrap.append(linha, remover);

  const onChange = () => {
    void persistirAtividades();
  };
  a.addEventListener('input', onChange);
  b.addEventListener('input', onChange);
  remover.addEventListener('click', () => {
    wrap.remove();
    void persistirAtividades();
    setLastEditNow();
  });

  return wrap;
}

export function getAtividades(): Atividade[] {
  const container = el<HTMLDivElement>(LIST_SEL);
  if (!container) return [];
  const rows = els<HTMLDivElement>('[data-atividade-row]', container);
  return rows.map(row => {
    const a =
      (el<HTMLInputElement>('.input-meta', row)?.value ??
        el<HTMLInputElement>('.input-nome', row)?.value ??
        '')!.trim();
    const b =
      (el<HTMLInputElement>('.input-indicador', row)?.value ??
        el<HTMLInputElement>('.input-valor', row)?.value ??
        '')!.trim();
    const nome: string = a || '';
    const valor: string = b || '';
    return { nome, valor };
  });
}

export function isAtividadesCompletas(list?: Atividade[]): boolean {
  const atividades = list ?? getAtividades();
  if (!atividades.length) return false;
  return atividades.every(a => {
    const nome = (a.nome ?? '').trim();
    const valor = (a.valor ?? '').trim();
    return nome.length > 0 && valor.length > 0;
  });
}

async function persistirAtividades() {
  const atual: DraftData =
    (await carregarRascunho()) || DEFAULT_DRAFT;

  const atividades: Atividade[] = getAtividades();

  const atividadesSanitizadas: Atividade[] = atividades.map(a => ({
    nome: (a.nome ?? '').toString(),
    valor: (a.valor ?? '').toString()
  }));

  const novo: DraftData = { ...atual, atividades: atividadesSanitizadas };
  await salvarRascunho(novo);

  atualizarChecklistAtividades(isAtividadesCompletas(atividadesSanitizadas));
}

export function initListaAtividades() {
  const add = document.getElementById(ADD_BTN_ID);
  const list = el<HTMLDivElement>(LIST_SEL);
  if (!list) return;

  add?.addEventListener('click', () => {
    list.appendChild(criarLinha());
    void persistirAtividades();
    setLastEditNow();
  });
}

export function preencherAtividades(atividades: Atividade[]) {
  const list = el<HTMLDivElement>(LIST_SEL);
  if (!list) return;
  list.innerHTML = '';
  atividades.forEach(a => list.appendChild(criarLinha(a)));
}

export function syncProgressoAtividades() {
  atualizarChecklistAtividades(isAtividadesCompletas());
}